import React, { Component } from "react"
import { initAction } from "../../../store/actions/cart"
import { connect } from "react-redux"
import { getItemsCount } from "../../../store/reducers"
import styled from "styled-components"
import fonts from "../../../styles/fonts"
import colors from "../../../styles/colors"
import { getCart } from "../../../services/cartHelper"
import { isBrowser } from "../../../services/browser"
import Bag from "./icons/Bag"

const StyledButton = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
`;

const ItemCount = styled.div`
  ${fonts.helveticaNeueCondensedMedium};
  color: ${colors.white};
  font-size: 10px;
  line-height: 12px;
  margin-left: ${(props) => (props.$cart ? "-9px" : "-6px")};
  border: 1px solid ${colors.green};
  background: ${colors.green};
  width: ${(props) => (props.$cart ? "19px" : "13px")};
  height: ${(props) => (props.$cart ? "19px" : "13px")};
  border-radius: 50%;
  position: relative;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  box-sizing: border-box;
  transform: translateY(-4px);
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

class BagLink extends Component {
  componentDidMount() {
    if (typeof window !== "undefined") {
      this.props.initAction()
    }
  }

  render() {
    const { itemsCount, setCartOpen, minicart, cartOpen } = this.props;

    let cartData;
    let cart;
    let setItems = []

    if (isBrowser()) {
      cartData = getCart();
    }
    if (cartData) {
      cart = JSON.parse(cartData);
      cart.items.forEach((item) => {
        const customAttributes = item.customAttributes;
        if (customAttributes) {
          customAttributes.forEach((custom) => custom.key === "Set" && setItems.push(item))
        }
      })
    }

    let fixedItemsCount = itemsCount - setItems.length / 2;
    return (
      <StyledButton
        onClick={() => setCartOpen(!cartOpen)}
        className={"bag"}
        $cart={minicart? 1 : 0}
      >
        <Bag large={minicart} />
        <ItemCount $visible={fixedItemsCount > 0? 1 : 0} $cart={minicart? 1 : 0}>
          {fixedItemsCount > 0 && <span>{fixedItemsCount}</span>}
        </ItemCount>
      </StyledButton>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    itemsCount: getItemsCount(state),
  }
};

const mapDispatchToProps = {
  initAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(BagLink)
